<template>
    <div>
        <div class="fw-gwitems">
            <van-tree-select
                    style="width: 100%"
                    :height="kdStyle"
                    :items="list"
                    :main-active-index.sync="activeIndex"
                    @click-nav="getItems"
                    v-if="list.length>0"
            >
                <template slot="content">
                    <div class="fw-gwitems-r">
                        <div class="fwgr-item" v-for="item in items">
                            <div class="fwgr-item-info">
                                <span class="mc">{{item.skuName}}</span>
                                <span class="jg">{{item.skuNo}}</span>
                            </div>
                            <el-button size="mini" @click="toChoose(item)">选择</el-button>
                        </div>
                    </div>
                </template>
            </van-tree-select>
        </div>

        <van-popup v-model="sepcShow" position="bottom" closeable lock-scroll overlay style="height: 100%">
            <div class="sousuo">
                <van-search
                        v-model="specName"
                        placeholder="规格"
                        shape="round"
                        style="width: 70%;"
                >
                </van-search>
                <span class="soubtn" @click="onSearch">搜索</span>
            </div>
            <div>
               <div style="margin-bottom: 16px">
                   <van-cell-group :border="false">
                       <van-field  :label-width="35" v-model="specNo" label="编码:" placeholder="输入编码" />
                       <span style="border-bottom: #EEEFEE solid 2px;"></span>
                   </van-cell-group>
               </div>
                <div style="margin-bottom: 16px;" v-if="memberId">
                    <div style="padding: 0 13px">
                        <div style="display: flex;flex-direction: row;justify-items: center;line-height: 30px;margin-left: 5px">
                            <span style="margin-right: 35px;font-size: 13px">赠送服务项目</span>
                            <el-button size="mini" type="text" @click="toItems">添加</el-button>
                        </div>
                    </div>
                    <div style="padding: 0 10px;margin-bottom: 35px"  v-if="dxItems.length>0">
                        <div class="sps">
                            <div class="spsitem" v-for="(item,index) in dxItems" :class="{'qudiao':index==0}">
                                <div class="l" style="width: 45%">
                                    <span>{{item.composeName}} ( ¥{{item.tcPrice}} )</span>
                                </div>
                                <div class="z">
                                    <van-stepper v-model="item.total" min="0" />
                                </div>
                                <div class="r">
                                    <span @click="delDxItem(index)">删除</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="spectabs">
                    <span>规格</span>
                    <span>库存</span>
                    <span>价格</span>
                    <span>操作</span>
                </div>
                 <div style="height: 200px; overflow: auto;">
                     <div class="spectab1" v-for="item in tmpSpList" @click="addSku(item)">
                         <span>{{item.spec}}</span>
                         <span>{{item.cpStock}}</span>
                         <span>{{item.retailPrice}}</span>
                         <span style="color: #2b94ff">选择</span>
                     </div>
                 </div>
            </div>
        </van-popup>

        <van-popup v-model="show" position="bottom" closeable lock-scroll overlay>
            <div style="padding: 15px;border-bottom: #EEEEEE solid 1px">
                <div class="fwgr-item-info">
                    <span class="mc">{{skuItem.skuName}}</span>
                    <span class="jg">¥{{spec.retailPrice}}</span>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">调整价格</span>
                        <el-input v-model="spec.total" size="mini" placeholder="请输入价格" class="ki"></el-input>
                    </div>
                </div>
            </div>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp"  v-for=" (emp,index) in fEmps">
                            <span class="empname" :class="{hui: emp.check}" @click="setEmp(emp,1)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp"  v-for=" emp in sEmps">
                            <span class="empname" :class="{hui: emp.check}"  @click="setEmp(emp,2)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp"  v-for=" emp in tEmps">
                            <span class="empname" :class="{hui: emp.check}" @click="setEmp(emp,3)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="adddatabtn" @click="addData"> 确定</div>
        </van-popup>

        <van-popup v-model="dxShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
         <div style="padding-top: 40px">
             <div style="padding: 10px;margin-bottom: 5px" v-if="composes.length>0">
                 <el-checkbox-group v-model="dxItemIds">
                     <el-checkbox style="margin-top: 3px" v-for="item in composes" :label="item.id"
                                  :key="item.id">
                         {{item.composeName}}
                     </el-checkbox>
                 </el-checkbox-group>
             </div>
             <div class="adddatabtn1" @click="setSyChecked"> 确定</div>
         </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                activeIndex: 0,
                list:[],
                items:[],


                show: false,
                item: {},
                fEmps: [],
                sEmps: [],
                tEmps: [],
                fName: '',
                sName: '',
                tName: '',

                total:0,

                specNo:'',
                specName:'',
                sepcShow:false,
                skuItem:{},
                spList:[],
                tmpSpList:[],

                spec:{},
                composes:[],
                dxItems:[],
                dxShow:false,
                dxItemIds:[],
            };
        },
        props:{
            memberId:String,
            kdStyle:String
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getCatItems()

        },
        methods: {
            async getCatItems() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                    isSell:2,
                    spec:2,
                }
                let res = await this.$get("/fw/getMdCatSkus", data)
                this.list = res.list
                if (res.list.length > 0) {
                    this.items = res.list[0].swSkus
                }
            },

            getItems(index) {
                this.items= this.list[index].swSkus
            },
            toItems() {
                this.dxShow = true
                this.getDxtcList()
            },
            //获取套餐列表
            async getDxtcList() {
                let res = await this.$get("/sw/getSwComposeSingleList", {token:this.token});
                this.composes = res.composes;
            },

            toChoose(item) {
                this.skuItem = item
                this.sepcShow = true
                this.getSkuSpec(item.id)
            },

            setSyChecked() {
                let arr = []
                this.composes.forEach(item => {
                    this.dxItemIds.forEach(id => {
                        if (id == item.id) {
                            arr.push({
                                id: item.id,
                                miType: 3,
                                itemId: item.itemId,
                                composeName: item.composeName,
                                tcPrice: item.tcPrice,
                                total: 1,
                            })
                        }
                    })
                })
                this.dxItems = arr
                this.dxShow=false
            },

            onSearch(){
                var name = this.specName.replace(/\s+/g, "");
                let specs = []
                this.spList.forEach(item => {
                    var newStr = item.spec.replace(/\s+/g, "");
                    let b = newStr.toUpperCase().match(name.toUpperCase())
                    if (b) {
                        specs.push(item)
                    }
                })
                if (specs.length > 0) {
                    this.tmpSpList = specs
                } else {
                    this.tmpSpList = []
                }
            },
            addSku(row) {
                let newItem = JSON.parse(JSON.stringify(row))
                newItem.total = newItem.retailPrice
                // if (newItem.discount == 1) {
                //     if (this.mbCard && this.mbCard.id) {
                //         //计算会员价
                //         if (this.mbCard.skuDiscount != 0) {
                //             newItem.total = this.calculationPrice(item.retailPrice, this.mbCard.skuDiscount)
                //         }
                //     }
                // }
             this.spec = newItem
             this.show=true
             this.getFwEmps()
            },
            async getSkuSpec(id) {
                let data = {
                    skuId: id,
                }
                let res = await this.$get("/fw/getFwSpecList", data)
                this.spList = JSON.parse(JSON.stringify(res.list))
                this.tmpSpList = JSON.parse(JSON.stringify(res.list))
            },

            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },

            addData() {
                let emps = []
                if (this.fEmps.length > 0) {
                    this.fEmps.forEach(item => {
                        if (item.check) {
                            emps.push({
                                empId: item.id,
                                empName: item.nickName,
                                station: 1,
                                gradeId: item.gradeId,
                                fdCmnVal: item.fdCmnVal,
                            })
                        }
                    })
                }
                if (this.sEmps.length > 0) {
                    this.sEmps.forEach(item => {
                        if (item.check) {
                            emps.push({
                                empId: item.id,
                                empName: item.nickName,
                                station: 2,
                                gradeId: item.gradeId,
                                fdCmnVal: item.fdCmnVal,
                            })
                        }
                    })
                }
                if (this.tEmps.length > 0) {
                    this.tEmps.forEach(item => {
                        if (item.check) {
                            emps.push({
                                empId: item.id,
                                empName: item.nickName,
                                station: 3,
                                gradeId: item.gradeId,
                                fdCmnVal: item.fdCmnVal,
                            })
                        }
                    })
                }
                let item = this.spec
                console.log(this.skuItem)
                let newItem ={
                    itemId: item.id,
                    categoryId: this.skuItem.categoryId,
                    storeDeptId: this.skuItem.storeDeptId,
                    itemName: this.skuItem.skuName,
                    cmnVal: this.skuItem.cmnVal,
                    fdCmnVal: this.skuItem.fdCmnVal,
                    cost: item.cost,
                    price: item.total,
                    oglPrice: item.retailPrice,
                    spec: item.spec,
                    itemSign: 0,
                    emps: emps,
                    dxItems:this.dxItems,
                    specNo:this.specNo,
                    actual: 0,
                    add: 0,
                    tjType: 0,
                };
                var total = parseFloat(this.total) + parseFloat(item.total)
                this.total = total.toFixed(1)
                let data ={
                    item:newItem,
                    total:item.total
                }
                this.$emit('toSpecChoose',data)
                this.show = false
                this.sepcShow = false
            },

            delDxItem(index) {
                let item = this.dxItems.splice(index, 1)
                let dxIndex = this.dxItemIds.indexOf(item.id)
                this.dxItemIds.splice(dxIndex, 1)
            },
            //设置员工
            async setEmp(item) {
              item.check = !item.check
            },

            // 将选中的人状态更改为没选中
            setUnchecked() {
                this.changeEmpFalse(this.emps);
            },

            //更改状态
            changeEmpTrue(emps, emp, check) {
                emps.forEach(item => {
                    if (emp.empId == item.id) {
                        item.check = check
                    }
                })
            },

            //更改状态
            changeEmpFalse(emps) {
                emps.forEach(item => {
                    item.check = false
                })
            },
            //计算价格
            calculationPrice(num1, num2) {
                var num = parseFloat(num1 * num2 / 10)
                return num.toFixed(1);
            },
        },
    };
</script>

<style lang="scss" scoped>


    .sousuo{
        padding: 15px;
        margin-top: 12px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center
    }
    .soubtn {
        width: 40px;
        font-size: 14px;
        margin: 0px 3px;
    }
    .spectabs{
        width: 98%;
        margin: auto;
        display: flex;
        flex-direction: row;
        padding-bottom: 5px;
        border-bottom: #EEEFEE solid 1px;
    }

    .spectabs span{
        width: 25%;
        padding: 3px;
        font-size: 13px;
        text-align: center;
    }

    .spectab1{
        width: 98%;
        margin: auto;
        display: flex;
        flex-direction: row;
        padding: 5px 0;
        border-bottom: #EEEFEE solid 1px;
    }

    .spectab1 span{
        width: 25%;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        text-align: center;
    }
    .sps {
        display: flex;
        flex-direction: column;
        padding: 0 8px;
    }

    .spsitem {
        display: flex;
        flex-direction: row;
        border-bottom: gainsboro solid 1px;
        padding: 3px 0px;
        justify-content: center;
        align-items: center;
        font-size: 13px;
    }

    .spsitem .l {
        width: 40%;
        display: flex;
        flex-direction: column;
    }

    .spsitem .z {
        width: 40%;
    }

    .spsitem .r {
        width: 20%;
    }
    .spsitem .r span {
        color: #FEA587;
        text-align: center;
        cursor: pointer;
        display: inline-block;
        margin: 0 8px;
    }
</style>
